export const BUGSNAG_API_KEY = "50ff67ad7a42645173d71622991177bf"
export const BUGSNAG_APP_VERSION = "42.2"

export enum Environment {
    Stable = "stable",
    Stage = "stage",
    Prod = "prod",
}

export const environmentUrls = {
    [Environment.Stable]: "stable.thescholasticnetwork.com",
    StableTsnVcs: "stable.tsnvcs.com",
    [Environment.Stage]: "stage.thescholasticnetwork.com",
    [Environment.Prod]: "portal.thescholasticnetwork.com",
}

export const CONTENT_MAX_SIZE = {
    image: 30 * 1024 * 1024,
    media: 2 * 1024 * 1024 * 1024,
    announcement: 5 * 1024 * 1024 * 1024,
    feed: 10 * 1024 * 1024,
    sound: 10 * 1024 * 1024,
}

export const MAX_VIDEO_DURATION_MIN = 10
export const MIN_VIDEO_DURATION_SEC = 5
export const ANNOUNCEMENT_VIDEO_DURATION_MIN = 20

export const CONTENT_MAX_FILES = {
    premiumLibrary: 25,
    common: 10,
}
